import React from 'react';
import Modal from './Modal';
import Button from '@components/forms/Button';

export interface ResultMessage {
  type: 'success' | 'error';
  message: string;
}

interface ResultModalProps {
  open: boolean;
  resultMessage: ResultMessage | null;
  onClose: () => void;
}

const ResultModal: React.FC<ResultModalProps> = ({
  open,
  resultMessage,
  onClose
}) => {
  if (!resultMessage) return null;

  return (
    <Modal
      title={resultMessage.type === 'success' ? 'Success' : 'Error'}
      size="md"
      open={open}
      onClose={onClose}>
      <div className="flex flex-col gap-[10px]">
        <div className="flex flex-col gap-[10px] text-[#475467]">
          <p className={resultMessage.type === 'success' ? 'text-green-600' : 'text-red-600'}>
            {resultMessage.message}
          </p>
        </div>
        <div className="mt-2">
          <div className="flex gap-4 justify-end">
            <Button
              data-dialog-close="true"
              className="font-semibold bg-primary normal-case rounded-lg text-base text-white w-auto whitespace-nowrap"
              onClick={onClose}>
              OK
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ResultModal;

